import React, { useEffect } from "react";
import { connect } from "react-redux";
import t from "i18n";
import { setEventDataTableAppTypeFilter } from "../../../actions/actions/eventStats";
import { countEventAppType } from "../../../actions/thunks/eventStats";
import omit from "lodash/omit";
import isEqual from "lodash/isEqual";

const AppTypeFilter = ({
  auth,
  eventStatsFilter,
  eventAppType,
  setEventDataTableAppTypeFilter,
  countEventAppType
}) => {

  const handleAppTypeSelect = (appType) => {
    setEventDataTableAppTypeFilter(appType);
  };

  const countAppType = () => {
    let params = {};

    if (eventStatsFilter.search.trim() !== "") {
      params.search = eventStatsFilter.search;
    }

    if (eventStatsFilter.year.length > 0) {
      params.year = eventStatsFilter.year;
    }

    if (auth.currentClient) {
      params.issuerId = auth.currentClient.id;
    }

    params.lang = eventStatsFilter.language;
    params.startMonth = eventStatsFilter.startMonth;
    params.endMonth = eventStatsFilter.endMonth;
    params.season = isNaN(eventStatsFilter.season) ? eventStatsFilter.season : Number(eventStatsFilter.season);

    countEventAppType(params);
  };

  // componentDidMount
  useEffect(() => {
    countAppType();
  }, []);

  // componentDidUpdate
  useEffect(() => {
    countAppType();
  }, [
    eventStatsFilter.search,
    eventStatsFilter.year,
    eventStatsFilter.language,
    eventStatsFilter.startMonth,
    eventStatsFilter.endMonth,
    eventStatsFilter.season
  ]);

  return (
    <div className={"circles_container"}>
      <ul>
        <li
          className={eventStatsFilter.appType.includes('registering') ? 'event-filter-app-type-registering selected' : 'event-filter-app-type-registering'}
          onClick={() => handleAppTypeSelect(['registering'])}
        >
          <span>{t('TRAININGS')} ({eventAppType.items.formation})</span>
        </li>
        {(auth.currentClient.businessType === 'SUPER_CHAIN' || auth.currentClient.businessType === 'MASTER_CHAIN') && (
          <li
            className={eventStatsFilter.appType.includes('cycle_registering') ? 'event-filter-app-type-cycle-registering selected' : 'event-filter-app-type-cycle-registering'}
            onClick={() => handleAppTypeSelect(['cycle_registering'])}
          >
            <span>{t('CYCLES')} ({eventAppType.items.cycle})</span>
          </li>
        )}
        {auth.currentClient.businessType === 'SUPER_CHAIN' && (
          <React.Fragment>
            <li
              className={eventStatsFilter.appType.includes('cycle_essential') ? 'event-filter-app-type-cycle-essential selected' : 'event-filter-app-type-cycle-essential'}
              onClick={() => handleAppTypeSelect(['cycle_essential'])}
            >
              <span>{t('CYCLES_ESSENTIAL')} ({eventAppType.items.cycle_essential})</span>
            </li>
            <li
              className={eventStatsFilter.appType.includes('all_in') ? 'event-filter-app-type-seasons selected' : 'event-filter-app-type-seasons'}
              onClick={() => handleAppTypeSelect(['all_in'])}
            >
              <span>{t('SEASONS')} ({eventAppType.items.all_in})</span>
            </li>
            <li
              className={eventStatsFilter.appType.includes('congres') ? 'event-filter-app-type-congres selected' : 'event-filter-app-type-congres'}
              onClick={() => handleAppTypeSelect(['congres'])}
              style={{ marginLeft: "10px" }}
            >
              <span>{t('CONGRESS')} ({eventAppType.items.congrès})</span>
            </li>
          </React.Fragment>
        )}
      </ul>
    </div>
  );
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventAppType: state.eventAppType,
  auth: state.auth,
});

const mapDispatchToProps = {
  setEventDataTableAppTypeFilter,
  countEventAppType,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppTypeFilter);


// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/AppTypeFilter.js